import {
  BillingCurrency,
  DEFAULT_BILLING_CURRENCY,
  TeamBillingPriceCurrencyOption,
} from '@this+that/models';

const LANGUAGE_PREFIX_TO_CURRENCY: Record<string, BillingCurrency> = {
  pt: BillingCurrency.BRL,
  'en-gb': BillingCurrency.GBP,
};

export function getCurrencyForLanguage(language: string): BillingCurrency {
  const normalizedLanguage = language.toLowerCase();
  const exactMatch = LANGUAGE_PREFIX_TO_CURRENCY[normalizedLanguage];
  if (exactMatch) {
    return exactMatch;
  }

  const languagePrefix = normalizedLanguage.split('-')[0];
  return (
    LANGUAGE_PREFIX_TO_CURRENCY[languagePrefix] ?? DEFAULT_BILLING_CURRENCY
  );
}

export interface PriceWithCurrencyOptions {
  unitAmount: number;
  currency: string;
  currencyOptions: TeamBillingPriceCurrencyOption[];
}

export interface ResolvedPriceAmount {
  unitAmount: number;
  currency: string;
}

export function pickPriceAmount(
  price: PriceWithCurrencyOptions,
  currency: BillingCurrency,
): ResolvedPriceAmount {
  const matchingOption = price.currencyOptions.find(
    (option) => option.currency === currency,
  );

  if (matchingOption) {
    return {
      unitAmount: matchingOption.unitAmount,
      currency: matchingOption.currency,
    };
  }

  return { unitAmount: price.unitAmount, currency: price.currency };
}
